var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body",attrs:{"id":"view"}},[_c('image-assets-preloader'),_vm._v(" "),_c('welcome-to-aloware'),_vm._v(" "),_c('div',{staticClass:"padding"},[_c('div',{staticClass:"padding card"},[_c('import-listing',{ref:"importListing"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }